import { useState, useEffect, useContext, useRef } from "react";
import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import { ActiveUserContext } from "../../components/Dashboard/Dashboard";

export default function useFreightMatchReceiver(type) {
  const activeUser = useContext(ActiveUserContext);
  const activeUserRef = useRef(activeUser);
  const [connection, setConnection] = useState(null);
  const [newNetworkMatches, setNewNetworkMatches] = useState(false);
  const [newCarrierMatches, setNewCarrierMatches] = useState(false);
  const [newLoadMatches, setNewLoadMatches] = useState(false);

  useEffect(() => {
    activeUserRef.current = activeUser;
  }, [activeUser]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (type === "carrier") {
        setNewCarrierMatches(true);
      } else if (type === "load") {
        setNewLoadMatches(true);
      } else {
        setNewNetworkMatches(true);
      }
    }, 300000);

    const newConnection = new HubConnectionBuilder()
      .withUrl("/FreightMatchingNotifications")
      .withAutomaticReconnect()
      .configureLogging(LogLevel.Information)
      .build();

    newConnection.onreconnected(() => {
      const user = activeUserRef.current;
      if (user?.userIdMcld) {
        newConnection.invoke("AddToGroup", user.userIdMcld);
      }
    });

    setConnection(newConnection);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    async function start() {
      try {
        await connection.start();
        await connection.invoke("AddToGroup", activeUser.userIdMcld);

        connection.on("FreightMatchingChange", update => {
          if (activeUser.userIdMcld === update) {
            if (type === "carrier") {
              setNewCarrierMatches(true);
            } else if (type === "load") {
              setNewLoadMatches(true);
            } else {
              setNewNetworkMatches(true);
            }
          }
        });
      } catch (err) {
        console.error(err);
      }
    }

    if (connection && activeUser.userIdMcld) {
      start();
    }
  }, [connection, activeUser]);

  return {
    newNetworkMatches,
    setNewNetworkMatches,
    newCarrierMatches,
    setNewCarrierMatches,
    newLoadMatches,
    setNewLoadMatches
  };
}